module.exports = __webpack_public_path__ + "static/media/noun-minus.886e9b17.svg";